<app-home-navigation></app-home-navigation>
<main>
    <section class="hero-section">
        <div>
            <picture>
               
                <source media="(min-width:1000px)" srcset="https://storage.googleapis.com/artifacts-healingourvillages/Untitled%20(13)/Desktop%20Header.png" type="image/png">
                <img src="https://storage.googleapis.com/artifacts-healingourvillages/Mobile_Marketing/Mobile%20Frame.png" type="image/png" width="414" height="227">
            </picture>
        </div>
       
        <div class="flex-column justify-around  section-text">
            <span class="mat-typography" >Join an accredited CDC Diabetes Prevention Program</span>
            <aside class="mat-typography">Our App is built for mobile! View on your mobile device and install our app!</aside>
            <pwa-install
            manifestPath="manifest.webmanifest"
            ></pwa-install>
        </div>
        <div class="hero-desktop-image">
            <picture>
                <source srcset="https://storage.googleapis.com/artifacts-healingourvillages/Desktop%20hero%20(2).webp" type="image/webp">
                <img src="https://storage.googleapis.com/artifacts-healingourvillages/Desktop%20hero%20(2).png" width="445px" height="494px" type="image/png">
            </picture>

        </div>
    </section>
    <section>
            <div class="flex-start feature-box justify-around align-center feature-second">
                    <picture>
                            <source media="(max-width:1000px)" srcset="https://storage.googleapis.com/artifacts-healingourvillages/Frame%2030.webp" type="image/webp">
                            <source media="(max-width:1000px)" srcset="https://storage.googleapis.com/artifacts-healingourvillages/Frame%2030%20(1).png" type="image/png">
                            <source media="(min-width: 1000px)" srcset="https://storage.googleapis.com/artifacts-healingourvillages/Group%202094.webp" type="image/webp">
                            <source media="(min-width: 1000px)" srcset="https://storage.googleapis.com/artifacts-healingourvillages/Group%202094.png" type="image/png">
                            <img src="https://storage.googleapis.com/artifacts-healingourvillages/Frame%2030%20(4).png" width="211" height="245" type="image/png">
                    </picture>
                    <div class="flex-column">
                        <h1 class="mat-typography">Video Guided Curriclum</h1>
                        <span class="mat-typography">
                                CDC approved Prevent T2 videos presented by Dr. Lenore T. Coleman, licensed Clinical Pharmacist (Pharm.D.) and Certified Diabetes Educator (CDE).             
                        </span>
                    </div>                    
            </div>
        </section>
    <section>
            <div class="flex-start feature-box justify-around align-center feature-second">
                    <div class="flex-column">
                        <h1 class="mat-typography">Live Chat</h1>
                        <span class="mat-typography">
                                Talk with your Healing Our Village (HOV) health professionals (Life Coaches, Pharmacists, Nutritionists and Personal Trainers)                 
                        </span>
                    </div>
                    <picture>
                        <source media="(max-width:1000px)" srcset="https://storage.googleapis.com/artifacts-healingourvillages/Mobile_Marketing/LiveChat%20Mobile%20(3).webp" type="image/webp">
                        <source media="(max-width:1000px)" srcset="https://storage.googleapis.com/artifacts-healingourvillages/Mobile_Marketing/LiveChat%20Mobile%20(3).png" type="image/png">
                        <source media="(min-width: 1000px)" srcset="https://storage.googleapis.com/artifacts-healingourvillages/Desktop_Marketing/LiveChat%20Desktop%20(2).webp" type="image/webp">
                        <source media="(min-width: 1000px)" srcset="https://storage.googleapis.com/artifacts-healingourvillages/Desktop_Marketing/LiveChat%20Desktop%20(2).png" type="image/png">
                        <img src="https://storage.googleapis.com/artifacts-healingourvillages/Mobile_Marketing/Frame%205%20(1).png" width="211" height="245" type="image/png">
                    </picture>
                    
            </div>
        </section>
    <section>
        <div class="flex-start feature-box justify-around align-center feature-second">
                <picture>
                    <source media="(max-width:1000px)" srcset="https://storage.googleapis.com/artifacts-healingourvillages/Mobile_Healhy%20(2).webp" type="image/webp">
                    <source media="(max-width:1000px)" srcset="https://storage.googleapis.com/artifacts-healingourvillages/Mobile_Healhy%20(2).png" type="image/png">
                    <source media="(min-width: 1000px)" srcset="https://storage.googleapis.com/artifacts-healingourvillages/Frame%2031%20(2).webp" type="image/webp">
                    <source media="(min-width: 1000px)" srcset="https://storage.googleapis.com/artifacts-healingourvillages/Frame%2031%20(2).png" type="image/png">
                    <img src="https://storage.googleapis.com/artifacts-healingourvillages/Mobile_Healhy%20(2).png" width="211" height="245" type="image/png">
                </picture>
                <div class="flex-column">
                    <h1 class="mat-typography">Recipes</h1>
                    <span class="mat-typography">
                            Delicious, Easy to cook low fat, heart healthy recipes that can help you lose 5-7% of your body weight in 90 days.                
                    </span>
                </div>
        </div>
    </section>

    <section class="cdc-header">
        <h1 class="mat-typography">About Healing Our Village</h1>
        <div class="flex-column brand-desc justify-around align-center">
            <span class="mat-typography">Healing Our Village with its partner Total Lifestyle Change is currently providing the Diabetes Prevention Program (DPP) curriculum approved by the CDC.</span>
            <span class="mat-typography">These classes are recommended for people with Body Mass Index greater than 30 ( Overweight or Obese), and patients with Diabetes or Prediabetes.</span>
        </div>
    </section>
</main>